import React from 'react';
import { Link } from 'react-router-dom';

import { trackDownloadIndividualSamples } from '../../../../analytics';

import { ZIP_URL } from '../../../../constants';
import { VideoMode } from '../../../../types';
import { UploadStage } from '../../components/types';

const getHlReelText = (props: {
  stage: UploadStage;
  orientation?: VideoMode;
  hasCreations: boolean;
  isPublic: boolean;
  isSample: boolean;
}) => {
  const { stage, orientation, hasCreations, isPublic, isSample } = props;

  const uploadInfoPoints = [
    'Your wildcard slots have the word "SHOT", on a white background',
    '"SHOT" is in large capitals using Arial or Helvetica in black font',
    'Your highlight reel is in MP4 or MOV format',
    !!orientation &&
      `Your highlight reel is in <b>${orientation}</b> orientation`,
  ].filter(Boolean) as string[];

  const summaryInfoPoints = [
    'Re-watch the uploaded highlight reel to ensure it includes "SHOT" wildcard slots',
    !hasCreations &&
      "Click 'Re-Upload' to upload a new highlight reel, but note that you won't be able to re-upload after the videos have been generated",
    !!orientation &&
      `Note that your highlight reel will be processed and optimised for <b>${orientation}</b>`,
  ].filter(Boolean) as string[];

  let subheading = isSample ? (
    <>
      <b>
        Use the highlight reel below by clicking on it to load it into your
        project.
      </b>
      <br />
      The highlight reel contains wildcard slots with the word "SHOT", our AI
      will substitute these with personalised selections for each person.
    </>
  ) : (
    <>
      Your highlight reel should contain wildcard slots with the word "SHOT",
      our AI will substitute these with personalised selections for each person.
      {stage === 'to-upload' && !isPublic && (
        <div className="mt-3 italic">
          Not sure what to upload?{' '}
          <Link
            to={ZIP_URL.FIFA_TEMPLATE_ZIP}
            onClick={() => trackDownloadIndividualSamples('hl_reel')}
          >
            Try our sample
          </Link>
        </div>
      )}
    </>
  );

  // to upload or uploading view
  if (stage !== 'summary') return { subheading, infoPoints: uploadInfoPoints };

  // highlight reel is uploaded
  return {
    subheading: isSample
      ? 'Watch the highlight reel below to better understand what wildcard slots are.'
      : null,
    infoPoints: summaryInfoPoints,
  };
};

export default getHlReelText;
